import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  idFrom:"",
  idTo:"",
  defaultStoreIdFrom:"",
  defaultStoreIdTo:"",
  formdiFrom:"",
  formdiTo:"",
  dateEmailFrom:null,
  dateEmailTo:null,
  store_IdToFrom:"",
  store_IdToTo:"",  
  slatypeFromES:"",
  slatypeToES:"",
  slatypeFromEN:"",
  slatypeToEN:"",
  incidenttypeFromES:"",
  incidenttypeToES:"",
  incidenttypeFromEN:"",
  incidenttypeToEN:"",
  resolutiontypeFromES:"",
  resolutiontypeToES:"",
  resolutiontypeFromEN:"",
  resolutiontypeToEN:"",
  isfinished:true,
  notisfinished:true,
  hasbeenread:true,
  nothasbeenread:true,
  
};

const filtersSentIncidentslice = createSlice({
  name: 'filtersSentIncidents',
  initialState,
  reducers: {
    setFilters(state, action) {
      return { ...state, ...action.payload };
    },
    resetFilters() {
      return initialState;
    },
  },
});

export const { setFilters, resetFilters } = filtersSentIncidentslice.actions;
export default filtersSentIncidentslice.reducer;
